import type { CategoryDefinition } from '@/types';

export const salonSpaCategories: readonly CategoryDefinition[] = [
  { id: 'salon-spa.hair',     name: 'Hair',     icon: 'scissors', color: 'pink',   order: 1, description: 'Cutting, washing and styling' },
  { id: 'salon-spa.colour',   name: 'Colour',   icon: 'wand',     color: 'purple', order: 2, description: 'Tints, highlights and toners' },
  { id: 'salon-spa.skin',     name: 'Skin',     icon: 'sun',      color: 'rose',   order: 3, description: 'Facials and waxing' },
  { id: 'salon-spa.grooming', name: 'Grooming', icon: 'feather',  color: 'slate',  order: 4, description: 'Beard and shaving services' },
  { id: 'salon-spa.spa',      name: 'Spa',      icon: 'heart',    color: 'violet', order: 5, description: 'Treatments and massage' },
];
